import { useContext } from 'preact/hooks'
import { useTranslation } from 'react-i18next'
import { AppContext } from '../main'
import { getLocalData } from '../services/storage'
import { getEmail } from '../utils'
import { EMAIL_REG_EXP } from '../constants'

const AcceptPolicy = ({ setIsPolicyAccepted, setHasEmailFilled }) => {
  const { t } = useTranslation()
  const { privacyUrl, playbookId } = useContext(AppContext)

  const handleCheckboxChange = e => {
    const actionCard = getLocalData(playbookId)
    const email = getEmail(actionCard)

    setIsPolicyAccepted(e.target.checked)
    setHasEmailFilled(!!EMAIL_REG_EXP.test(email))
  }

  return (
    <label className="text-center px-4 text-sm dark:text-zinc-400">
      <input type="checkbox" onChange={handleCheckboxChange} className="align-middle relative bottom-0.5 mr-1" />
      {t('policy.leading', 'I have read the')}
      <a className="underline text-[#bbb] px-1" href={privacyUrl} target="_blank">
        {t('policy.link', 'terms and privacy policy')}
      </a>
      {t('policy.tailing', '')}
    </label>
  )
}

export default AcceptPolicy
